// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"faf294fd","70":"32fef241","190":"23ed21df","249":"c7bcb34a","284":"a2bec5e8","388":"c79cad92","453":"f70db82f","521":"73cbb1e4","704":"ac6aa194","761":"a14245a0","775":"2b2c32da","822":"08657954","891":"e949980c","912":"8c4d4684","921":"a81de450","975":"0379dbd7"}[chunkId] + ".chunk.js";
};